import { AsyncValidatorFn } from '@angular/forms';
import { Observable, catchError, map, of, switchMap, timer } from 'rxjs';

export const INVALID_CODE_ERROR = 'invalidCode';

const CHECK_DEBOUNCE_IN_MS = 400;

export function verificationCodeValidator(check: (code: string) => Observable<boolean>): AsyncValidatorFn {
  return (control) =>
    timer(CHECK_DEBOUNCE_IN_MS).pipe(
      switchMap(() => check(String(control.value))),
      catchError(() => of(false)),
      map((valid) => (valid ? null : { [INVALID_CODE_ERROR]: true }))
    );
}
